import { api } from '../api';

export const staffService = {
  addStaff: (data) => api.post('/staff', data),
  getAll: () => api.get('/staff'),
};
